import React, { useRef, useMemo, useEffect } from 'react';
import { Timeline as Timeline$1 } from '@knight-lab/timelinejs';
import styles from './styles.module.css.js';

const timelineOptions = {
  scale_factor: 1.4,
  timenav_position: 'top',
  height: '500',
  width: '100%',
  lang: 'en',
  start_at_end: true,
  font: 'Roboto Slab'
};
function Timeline(props) {
  const {
    data
  } = props;
  const dummyRef = useRef(null);
  const finalEvents = useMemo(() => data.map(datum => ({
    start_date: new Date(datum.date),
    display_date: new Date(datum.date).toDateString(),
    group: datum.category,
    text: {
      headline: datum.title,
      text: datum.details
    }
  })), [data]);
  useEffect(() => {
    // eslint-disable-next-line no-new
    new Timeline$1(dummyRef.current, {
      events: finalEvents
    }, timelineOptions);
  }, [finalEvents]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.myContainer
  }, /*#__PURE__*/React.createElement("div", {
    ref: dummyRef
  }));
}

export { Timeline as default };
//# sourceMappingURL=index.js.map
